import { Button, Card, Flex, Typography } from 'antd'
import React from 'react'
import { useAuth } from '../../auth'
import { useTranslation } from 'react-i18next'
import { UpgradeModal } from './upgrade-modal'

type BillingCardProps = {
    upgrade?: boolean
    onUpgradeClick: () => void
    onCloseModal: () => void
}

export function BillingCard({ upgrade = false, onUpgradeClick, onCloseModal }: BillingCardProps) {
    const { activeCompany, onTrial, user } = useAuth()
    const { t } = useTranslation()
    const locale = (user?.locale || '').split('_')[0]

    return (
        <>
            <Card className="w-full">
                <Flex
                    justify="space-between"
                    align="center"
                >
                    <div>
                        <Typography.Text type="secondary">{t('Your plan')}</Typography.Text>
                        <Typography.Title
                            level={4}
                            className="mt-2 mb-0"
                        >
                            {activeCompany?.tier ? t(`tier.${activeCompany.tier}`) : ''}
                            {activeCompany?.period ? ` - ${t(activeCompany.period)}` : ''}
                        </Typography.Title>
                        {onTrial && activeCompany?.trialEndsAt && (
                            <Typography.Text
                                type="secondary"
                                className="mt-2 block"
                            >
                                {t('Free trial until {{date}}', {
                                    date: activeCompany.trialEndsAt.toLocaleString(locale, {
                                        dateStyle: 'medium',
                                        timeStyle: 'short',
                                    }),
                                })}
                            </Typography.Text>
                        )}
                    </div>
                    {/* An upgrade needs a working payment; the alert at the top asks to fix that first. */}
                    {!activeCompany?.paymentFailing && (
                        <Button
                            type="primary"
                            onClick={onUpgradeClick}
                        >
                            {t('Upgrade')}
                        </Button>
                    )}
                </Flex>
            </Card>

            <UpgradeModal
                open={upgrade}
                onClose={onCloseModal}
            />
        </>
    )
}
